import { useEffect, useState } from "react"
import Utils from "Services/Utils"
import { TResultProduct } from "types"

const useBackingData = () => {
    const [backingDataInfo, setBackingDataInfo] = useState<{[x:string]: string}|undefined>(undefined)
    const [isBackingModelOpen, setIsBackingModelOpen] = useState<{product: TResultProduct, callback?: Function}|undefined>(undefined)

    useEffect(() => {
        const targetParams = ['backing_option', 'lefthand_righthand', 'install_fly_line'];
          
        // Use the hook to get parameters from URL hash
        const options = Utils.extractHashParams(targetParams);
        // cart.find((product) => product.categoryName === "Fly Reel") && 
        setBackingDataInfo(options)
    }, [])

    const openBackingModal = (product: TResultProduct, callback?: Function) => {
        setIsBackingModelOpen({product, callback})
    }

    function checkBackingOption() {
        // Get the backing_option value
        const backingOption = backingDataInfo?.backing_option
        
        // Check if it's one of the specified values
        const isValidBacking = backingOption === "20 lb Dacron" || backingOption === "30 lb Dacron";
        return isValidBacking && backingOption;
    }

    return {
        backingDataInfo,
        isBackingModelOpen,
        setIsBackingModelOpen,
        setBackingDataInfo,
        openBackingModal,
        checkBackingOption
    }
}

export default useBackingData